// bigger number == better quality and worse optimisation (1.0 to 1.9)
export const OFFSET = 1.25;
export const GIF_OFFSET = 1;
export const MOBILE_OFFSET = 3;

// prevents gif from enlarging to sky-high sizes
export const GIF_MAX_WIDTH = 900;
